import Vue from 'vue'
import moment from 'moment'
import i18n from '@/plugins/i18n.js'

Vue.filter('amount', function(value) {
  return (parseFloat(String(value)) / 100).toFixed(2)
})
Vue.filter('hundred', function(value) {
  return (parseInt(String(value)) / 100)
})
Vue.filter('currency', function(value) {
  return value !== null ? (value / 100).toLocaleString(i18n.locale, { style: 'currency', currency: Vue.config.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
})
Vue.filter('size', function(value) {
  return (parseFloat(String(value)) / 1024).toFixed(0) + '\u00a0' + 'KB'
})
Vue.filter('timeLength', function(value) {
  var val = Math.floor(parseInt(value) / 1000)
  return Math.floor(val / (60 * 60)) + ':' + ('0' + (Math.floor(val / 60) % 60)).slice(-2) + ':' + ('0' + (val % 60)).slice(-2)
})
Vue.filter('moment', function(value, format) {
  const frmt = 'YYYY-MM-DD HH:mm:ss.SSSSSSSSS z'
  if (value === null || value === undefined) return ''
  const val = moment.isMoment(value) ? value : moment.isDate(value) ? moment(value) : moment(value.toString(), frmt)
  return val.format(format)
})
Vue.filter('minutes', function(value) {
  return Math.floor(value / 60) + ':' + ('0' + (value % 60)).slice(-2)
})

Vue.prototype.$filters = Vue.options.filters
